import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { Redirect } from 'react-router-dom';
import { getSite } from '../../infrastructure/site/SiteProvider';
import { Button } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { PageTitle } from '../../uiComponents/layout/PageTitle';
import { ContentWrapper } from '../../uiComponents/layout/ContentWrapper';
import { PageWrapper } from '../../uiComponents/layout/PageWrapper';
import { SectionGroup } from '../../uiComponents/layout/SectionGroup';
import { LinkSecondaryButton } from '../../uiComponents/input/Buttons';
import { createApiCaller } from '../../infrastructure/api/ApiFactory';
import { getLoggedInBruger, erElev } from '../../infrastructure/Security';

export interface BetingelserState {
    acceptedTerms: boolean;
}

class Brugervilkaar extends React.Component<RouteComponentProps<any>, BetingelserState> {
    constructor(props: RouteComponentProps<any>) {
        super(props);
        this.state = { acceptedTerms: false };
    }

    onAcceptTerms() {
        const currentUser = getLoggedInBruger();
        currentUser.accepteretVilkaar = true;

        const resultPromise = createApiCaller().updateBruger(currentUser);
        resultPromise.then(json => { 
            if (json) {
                localStorage.setItem('token', json.token);
                this.setState({ acceptedTerms: true });
            }
        });
    }

    forcedtoAcceptBrugervilkaar() {
        const isForcedToAccept: boolean = this.props.location && this.props.location.state && this.props.location.state.forceAcceptBrugervilkaar && !erElev();
        return isForcedToAccept;
    }

    getButtons() {
        return (
            <div className='brugerVilkaarButtons'>
                <Button buttonType='primary' onClick={() => this.onAcceptTerms()}>Acceptér</Button>
                <LinkSecondaryButton className='spacer' url='/Logout' text='Log ud' />
            </div>
        );
    }

    getHeader() {
        const siteName = getSite().navn;
        const headline = this.forcedtoAcceptBrugervilkaar() ? 'For at bruge ' + siteName + ' skal du acceptere brugervilkårene'
                                                : 'Betingelser for brug af ' + siteName;
        return (
            <div>
                <h3>
                    {headline}
                </h3>
                <br />
            </div>
        );
    }

    getBrugervilkaar() {
        return (
            <div>
                <p>For at kunne afvikle Naturfagsmaraton er det nødvendigt for Naturvidenskabernes Hus A/S at opbevare og benytte oplysninger om de deltagende skoler og brugere.
                     Det drejer sig om skolens navn, og hvilke klasser der deltager. Derudover opbevarer vi og benytter navne og e-mailadresse på de deltagende brugere og 
                     eventuelle indtastninger i logbogen. 
                </p><br />
                <p>Naturvidenskabernes Hus A/S videregiver ikke de registrerede personoplysninger til tredjemand. Som undtagelse hertil er tredjemand,
                     der benytter data på Naturvidenskabernes Hus’ ordre, som fx en it-leverandør der skal lave ændringer på hjemmesiden.
                      Naturvidenskabernes Hus kan endvidere videregive en deltagerliste til de øvrige tilmeldte deltagere af arrangementet samt arrangører af arrangementet. 
                </p><br />
                <p>Du kan altid få indsigt i, hvilke oplysninger vi har om dig og eventuelt få dem slettet. Du kan også trække dit samtykke tilbage. 
                    Ved tilmelding gemmes dine oplysninger af Naturvidenskabernes Hus A/S i op til fem år. Dog slettes korrespondancer i logbogen årligt i august.
                    Som bruger er du ansvarlig for selv at holde dig opdateret på eventuelle ændringer i brugervilkårene. Brugervilkår kan altid tilgås ved at logge ind på Naturfagsmaraton, 
                    hvor brugervilkårene tilgåes under brugermenuen i øverste højre hjørne.
                </p><br />
                <p>
                    For spørgsmål vedrørende brugervilkår kan du kontakte Naturvidenskabernes hus via <a href='https://www.nvhus.dk/om-os/kontakt/'>https://www.nvhus.dk/om-os/kontakt/</a> 
                </p><br />
                <p>Ved deltagelse i konkurrencedagen i Naturfagsmaraton er tilsynet med eleverne skolens ansvar. Se Bekendtgørelse om tilsyn med folkeskolens elever i skoletiden 
                    <a href='https://www.retsinformation.dk/Forms/R0710.aspx?id=72919'> https://www.retsinformation.dk/Forms/R0710.aspx?id=72919</a>
                </p><br />
            </div>
        );
    }

    render() {
        return (
            <PageWrapper>
                {this.state.acceptedTerms && <Redirect to={'/'} />}
                <PageTitle title='Brugervilkår' />
                    <ContentWrapper>
                        <SectionGroup>
                        <div className='brugerVilkaar'>
                            {this.getHeader()}
                            {this.getBrugervilkaar()}
                            {this.forcedtoAcceptBrugervilkaar() && this.getButtons()}  
                        </div>
                        </SectionGroup>
                    </ContentWrapper>
            </PageWrapper>
        );
    }
}

export default Brugervilkaar;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/brugervilkaar/Brugervilkaar.tsx